import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=e7968088&scoped=true"
import script from "./TestResult.vue?vue&type=script&lang=js"
export * from "./TestResult.vue?vue&type=script&lang=js"
import style0 from "./TestResult.vue?vue&type=style&index=0&id=e7968088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7968088",
  null
  
)

export default component.exports